var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-reject.a97f7a8d.png","uri@2x": __webpack_public_path__ + "icon-reject.cb6ed948.png","uri@3x": __webpack_public_path__ + "icon-reject.e109690c.png",
    width: 40,
    height: 40
});